import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  card: {
    position: 'relative',
    textAlign: 'center',
    marginBottom: 20,
    minHeight: 200,
    border: '1px solid #9e9e9e',
    borderRadius: 8,
    boxShadow: 'unset'
  },
  descriptionBox: {
    position: 'absolute',
    bottom: -120,
    width: '100%',
    height: 160,
    backgroundColor: '#9e9e9e',
    transition: 'all 0.5s',
    padding: 8,
    paddingTop: 40,
    boxSizing: 'border-box',
    color: '#000000',
    fontSize: '0.9em'
  },
  iconAdd: {
    position: 'absolute !important',
    right: 10,
    top: 5,
    zIndex: 1
  },
  title: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    top: 0,
    color: 'black',
    minWidth: 300,
    textAlign: 'center'
  }
}));

export default useStyles;
